<ng-template #displayTemplateRef
             let-cellData
             let-rowData="rowData">
  @if (cellData?.length && getDistinctItems(cellData); as listItems) {
    @if (renderAsCommaSeparatedList) {
      <div class="flex flex-wrap">
        @for (data of cellData; track data; let isLast = $last) {
          <div class="max-w-full inline-block white-space-nowrap">
            <div class="max-w-full inline-block">
              <ng-container *ngTemplateOutlet="itemTemplate;context: {$implicit: data, rowData: rowData}">
              </ng-container>
            </div>
            <div class="sc-list-separator">
              @if (!isLast) {
                <span>,</span>
              }
            </div>
          </div>
        }
      </div>
    } @else {
      <div class="flex align-items-center justify-content-start sc-overflow-ellipsis">
        <ng-container *ngTemplateOutlet="itemTemplate;context: {$implicit: listItems[0], rowData: rowData}">
        </ng-container>
        @if (listItems.length > 1) {
          <p-button styleClass="p-button-rounded p-button-text p-button-sm ml-1 p-2"
                    (onClick)="listItems.length <= 10 ? listPanel.toggle($event) : listPanelFull.toggle($event)"
                    [label]="'+' + (listItems.length - 1)">
          </p-button>
          <p-popover #listPanel
                     appendTo="body">
            @for (listItem of listItems.slice(1); track listItem; let isLast = $last) {
              <div class="flex flex-column">
                <ng-container *ngTemplateOutlet="itemTemplate;context: {$implicit: listItem, rowData: rowData}">
                </ng-container>
                @if (!isLast) {
                  <hr>
                }
              </div>
            }
          </p-popover>
          <p-popover #listPanelFull
                     appendTo="body">
            <div class="grid">
              @for (listItem of listItems.slice(1); track listItem; let isLast = $last) {
                <div class="col-2 flex">
                  <ng-container *ngTemplateOutlet="itemTemplate;context: {$implicit: listItem, rowData: rowData}">
                  </ng-container>
                </div>
              }
            </div>
          </p-popover>
        }
      </div>
    }
  }
</ng-template>